/**
 * Asset Statistics Cards Component
 * Displays asset counts by lifecycle status
 */

import { StatCard } from '../ui/stat-card';
import { useAssetStatsStore } from '../../stores/asset-stats';
import {
  Package,
  DollarSign,
  TrendingUp,
} from 'lucide-react';

export function AssetStatCards() {
  useAssetStatsStore.live();
  const stats = useAssetStatsStore(s => s.stats);
  const isLoading = useAssetStatsStore(s => s._loading);

  if (isLoading) {
    return (
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="h-[120px] animate-pulse rounded-lg bg-muted"
          />
        ))}
      </div>
    );
  }

  const inventoried = stats?.byStatus['Inventoried'] || 0;
  const listedForSale = stats?.byStatus['Listed for Sale'] || 0;
  const sold = stats?.byStatus['Sold'] || 0;
  const total = stats?.total || 0;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <StatCard
        title="Total Assets"
        value={total.toLocaleString()}
        icon={Package}
        description="All tracked items"
      />
      <StatCard
        title="Inventoried"
        value={inventoried.toLocaleString()}
        icon={Package}
        description="Awaiting valuation"
      />
      <StatCard
        title="For Sale"
        value={listedForSale.toLocaleString()}
        icon={TrendingUp}
        description="Currently listed"
      />
      <StatCard
        title="Sold"
        value={sold.toLocaleString()}
        icon={DollarSign}
        description="Completed sales"
      />
    </div>
  );
}
